module.exports = __webpack_public_path__ + "img/744.8908d86a.jpg";